/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {BaseValidator} from "./BaseValidator";

export class HiddenFieldValidator extends BaseValidator {
	constructor(otherField, validators = null, messageString = null) {
		super();
		this.otherField = otherField;
		this.validators = validators;
		this.messageString = messageString;
		this.lastFailureMessage = 'Invalid data for ' + otherField
	}

	name(model) {
		return this.messageString(model)
	}

	logic(x, model, data) {

		let fieldDef = model.fieldDefs.find((x) => x.key == this.otherField);

		let validators = this.validators || fieldDef.validators;

		let value = data[this.otherField];

		for (let validator of validators) {
			if (!validator.logic(value, model, data)) {
				this.lastFailureMessage = validator.message(model);
				return false;
			}
		}

		return true;
	}

	message(model) {
		return this.messageString || this.lastFailureMessage;
	}
}